import { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";

const nodes = [
  { id: "ia", x: 66, y: 42, r: 7, label: "IA", primary: true },
  { id: "org", x: 40, y: 30, r: 4, label: "Organisations" },
  { id: "data", x: 82, y: 60, r: 4, label: "Données" },
  { id: "tech", x: 55, y: 68, r: 4, label: "Technologies" },
  { id: "users", x: 30, y: 62, r: 4, label: "Utilisateurs" },
  { id: "market", x: 74, y: 22, r: 3, label: "Marchés" },
  { id: "n1", x: 48, y: 48, r: 2 },
  { id: "n2", x: 62, y: 55, r: 2 },
  { id: "n3", x: 90, y: 38, r: 2 },
  { id: "n4", x: 22, y: 40, r: 2 },
];

const byId = Object.fromEntries(nodes.map((n) => [n.id, n]));
const links = [
  ["ia", "org"], ["ia", "data"], ["ia", "tech"], ["ia", "market"],
  ["org", "users"], ["tech", "n2"], ["n1", "org"], ["n1", "users"],
  ["data", "n3"], ["ia", "n2"], ["users", "n4"], ["n2", "tech"],
];

export const EcosystemGraphic = () => {
  const ref = useRef(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const onMove = (e) => {
      const px = (e.clientX / window.innerWidth - 0.5) * 2;
      const py = (e.clientY / window.innerHeight - 0.5) * 2;
      setOffset({ x: px * 14, y: py * 14 });
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  return (
    <div ref={ref} className="absolute inset-0 h-full w-full">
      <motion.svg
        viewBox="0 0 100 80"
        preserveAspectRatio="xMidYMid slice"
        className="h-full w-full opacity-90"
        animate={{ x: offset.x, y: offset.y }}
        transition={{ type: "spring", stiffness: 40, damping: 20 }}
      >
        <defs>
          <radialGradient id="glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#00E5FF" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#00E5FF" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="lineGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#00E5FF" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#4338CA" stopOpacity="0.25" />
          </linearGradient>
        </defs>

        {links.map(([a, b], i) => {
          const na = byId[a], nb = byId[b];
          return (
            <motion.line
              key={i}
              x1={na.x} y1={na.y} x2={nb.x} y2={nb.y}
              stroke="url(#lineGrad)"
              strokeWidth="0.12"
              initial={{ pathLength: 0, opacity: 0 }}
              animate={{ pathLength: 1, opacity: 1 }}
              transition={{ duration: 1.6, delay: 0.6 + i * 0.08, ease: "easeInOut" }}
            />
          );
        })}

        {nodes.map((n, i) => (
          <motion.g
            key={n.id}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, delay: 0.7 + i * 0.06, ease: [0.22, 1, 0.36, 1] }}
          >
            <motion.g
              animate={{ y: [0, i % 2 ? 1.2 : -1.2, 0] }}
              transition={{ repeat: Infinity, duration: 5 + i, ease: "easeInOut" }}
            >
              {n.primary && <circle cx={n.x} cy={n.y} r={n.r * 2.6} fill="url(#glow)" opacity="0.5" />}
              <circle
                cx={n.x} cy={n.y} r={n.r / 3.2}
                fill={n.primary ? "#00E5FF" : "#7dd3fc"}
                opacity={n.primary ? 1 : 0.85}
              />
              {n.primary && (
                <circle cx={n.x} cy={n.y} r={n.r / 2} fill="none" stroke="#00E5FF" strokeWidth="0.1" opacity="0.6" />
              )}
            </motion.g>
          </motion.g>
        ))}
      </motion.svg>
    </div>
  );
};
